import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as marked from 'marked';

@Pipe({ name: 'markdown', standalone: false })
export class MarkdownPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string): string {
        if (!value) return '';
        if (value.length > 50000) return value;
        const html = (marked.parse(value) as string).trim();
        return this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
    }
}
